import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import MarketPlaceBar from "../../components/marketplace/MarketPlaceBar";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import StoreCard from "../../components/marketplace/StoreCard";
import ProductCard from "../../components/marketplace/ProductCard";
import useCart from "../../components/helpers/cartHook";

const ProductPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('المتاجر');
    const [userData, setUserData] = useState(null);

    const {id, storeId, storeProductId} = useParams();

    const [selectedUnit, setSelectedUnit] = useState(null);
    const [stores, setStores] = useState(null);

    const [product, setProduct] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const [quantity, setQuantity] = useState(1);

    const navigate = useNavigate();

    const { cart, addToCart, removeFromCart, updateQuantity, clearCart, getCartTotal } = useCart();

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getNearbyStores = async () => {
        setIsLoading(true);
      try {
        const response = await apiClient.get(`/stores/nearby?longitude=${selectedUnit?.long}&latitude=${selectedUnit?.lat}`);
        if(response?.data) {
          setStores(response?.data);
          setIsLoading(false);
        } else {
            setIsLoading(false);
        }
      } catch(err) {setIsLoading(false);}
    }

    useEffect(()=>{
        if(selectedUnit) {
            getNearbyStores();
            getProduct();
        }
    },[selectedUnit]);

    const handleClickProduct = (id) => {
        navigate(`/ar/marketplace/product/${id}`);
    }

    const getProduct = async () => {
      try {
        const response = await apiClient.get(`/store-products/details?productId=${id}&storeId=${storeId}`);
        if(response?.data) {
          setProduct(response?.data);
        } else {
        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(id) {
            getProduct();
        }
    },[id])

    

  return (
    <div>
            <PageHeader pageTitle={{title: product ? product?.productDetails?.name : ''}} userCallback={handleGetUser} cart={true} cartContent={cart} isColored />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>
                    
                    {product && <div className="">
                        <div className="flex flex-nowrap gap-x-[25px]">
                            <div className="w-[443px] h-[400px] rounded-[8px] !bg-no-repeat !bg-contain cursor-pointer select-none" style={{background: `#fff url(${product?.productDetails?.thumbnail}) no-repeat center center / cover`}}>
        
                            </div>
                            <div className="w-[calc(100%-443px)]">
                                <h2 className="text-black font-[600] text-[22px] pt-[15px]">{product?.productDetails?.name}</h2>
                                <p className="font-[700] text-[32px] text-neutral900 pt-[15px]">{product?.variants[0]?.finalPrice?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[20px] align-middle inline-block select-none" /></p>
                                <div className=" border-y-[1px] border-y-grey-200 py-[15px] max-w-[443px] mt-[25px]">
                                    <p className="text-[14px] font-[700] text-grey-900 pb-[5px]">الكمية</p>
                                    <div className="flex flex-nowrap gap-x-[10px]">
                                        <div className="w-[100px]">
                                            <select className="h-[56px] leading-[56px] rounded-[12px] bg-[transparent] w-full border-[1px] border-neutral80 outline-none font-[600] text-[14px] px-[8px]" onChange={(e)=>setQuantity(e?.target?.value)}>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                            </select>
                                        </div>
                                        <div className="w-[calc(100%-100px)]">
                                            <div className="text-white text-center text-[18px] font-[700] rounded-[12px] bg-blue leading-[56px] h-[56px] cursor-pointer select-none" onClick={()=>addToCart({workerRequired: true,storeProductId: storeProductId, variantId: product?.variants[0]?._id, quantity: parseInt(quantity), image: product?.productDetails?.thumbnail, price: product?.variants[0]?.finalPrice?.toFixed(2), name: product?.productDetails?.name })}>أضف للسلة</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-[680px] h-[64px] my-[25px]" style={{background: "url('/assets/images/product-bar.svg')"}}></div>
                                <p className="text-[14px] font-[700] text-grey-900 pb-[5px]">وصف المنتج</p>
                                <p className="text-grey-800 font-[400] text-[16px]">{product?.productDetails?.description[0]?.value}</p>
                            </div>
                        </div>
                    </div>}
                    
                </MainContent>
            </PageMain>

            {isLoading && <Loading showLoading={true} />}
    </div>
  );
};

export default ProductPage;
